import React from 'react'
import Box from '@material-ui/core/Box'

import { useStyles } from './styles'
import Chip from '@material-ui/core/Chip'
import differenceInDays from 'date-fns/differenceInDays'
import parseISO from 'date-fns/parseISO'

const ChipsSection = ({
  status,
  requiresAccessCode,
  lessonCreditBalanceQuantity,
  isSingleSession,
  withLessonPacksCard,
  nextExpirationDate,
}) => {
  const classes = useStyles()
  const daysToExpire = differenceInDays(
    parseISO(nextExpirationDate),
    new Date(),
  )
  const showExpireWarning = daysToExpire < 30

  return (
    <Box display="flex">
      {status === 'INACTIVE' && (
        <Chip
          className={`${classes.chip} ${classes.chipPrivate}`}
          label="Private"
        />
      )}
      {requiresAccessCode && !lessonCreditBalanceQuantity && (
        <Chip
          className={`${classes.chip} ${classes.chipAttention}`}
          label="Access Code"
        />
      )}
      {!isSingleSession && withLessonPacksCard ? (
        <Chip
          className={`${classes.chip} ${classes.chipInfo}`}
          label="Lesson Pack"
        />
      ) : null}
      {lessonCreditBalanceQuantity && isSingleSession ? (
        <Box display="flex" alignItems="center">
          {showExpireWarning && (
            <Chip
              className={`${classes.chip} ${classes.chipWarning}`}
              label="Expires Soon"
            />
          )}
          <Chip
            className={`${classes.chip} ${classes.chipSuccess}`}
            label="Purchased"
          />
          <Chip
            className={`${classes.chip} ${classes.chipInfo}`}
            label={`${lessonCreditBalanceQuantity} lessons left`}
          />
        </Box>
      ) : null}
    </Box>
  )
}

export default ChipsSection
